export default __webpack_public_path__ + "static/media/oportunidades_de_emprego.1093003a.mp4";